export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      title: true,
      name: 'Entities',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Admins',
      url: '/admins',
      icon: 'fa fa-shield'
    },
    {
      name: 'Appointments',
      url: '/appointments',
      icon: 'fa fa-calendar'
    },
    {
      name: 'Call-backs',
      url: '/call-backs',
      icon: 'fa fa-phone',
      badge: {
        variant: 'success',
        text: 'NEW'
      }
    },
    {
      name: 'Patients',
      url: '/patients',
      icon: 'fa fa-users',
      badge: {
        variant: 'success',
        text: 'NEW'
      }
    },
    {
      name: 'Clinical activity',
      url: '/reports/clinical-activity',
      icon: 'fa fa-bar-chart',
      badge: {
        variant: 'success',
        text: 'NEW'
      }
    },
    {
      name: 'Tracking',
      icon: 'fa fa-line-chart',
      badge: {
        variant: 'success',
        text: 'NEW'
      },
      children: [
        {
          name: 'Dashboard',
          url: '/tracking/overview',
          icon: 'fa fa-dashboard'
        },
        {
          name: 'Live now',
          url: '/tracking/live-journeys',
          icon: 'fa fa-bolt'
        },
        {
          name: 'All journeys',
          url: '/tracking/sessions',
          icon: 'fa fa-list'
        },
        {
          name: 'Drop-off steps',
          url: '/tracking/funnels',
          icon: 'fa fa-filter'
        },
        {
          name: 'Busy times',
          url: '/tracking/traffic',
          icon: 'fa fa-line-chart'
        },
        {
          name: 'Problems',
          url: '/tracking/errors',
          icon: 'fa fa-exclamation-triangle'
        },
        {
          name: 'API performance',
          url: '/tracking/apis',
          icon: 'fa fa-exchange'
        },
        {
          name: 'Doctor slots',
          url: '/tracking/capacity',
          icon: 'fa fa-calendar'
        },
        {
          name: 'Support calls',
          url: '/tracking/support',
          icon: 'fa fa-headphones'
        },
        {
          name: 'Fixes',
          url: '/tracking/issues',
          icon: 'fa fa-bug'
        },
        {
          name: 'Weekly story',
          url: '/tracking/weekly-report',
          icon: 'fa fa-file-text-o'
        }
      ]
    },
    {
      name: 'Orders',
      icon: 'fa fa-shopping-cart',
      children: [
        {
          name: 'All orders',
          url: '/orders/all',
          icon: 'fa fa-tasks'
        },
        {
          name: 'GPS orders',
          url: '/orders/gps',
          icon: 'fa fa-tasks'
        },
        {
          name: 'DocNow orders',
          url: '/orders/docnow',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Prescriber orders',
          url: '/orders/prescriber',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Repeat orders',
          url: '/orders/repeat-orders',
          icon: 'fa fa-tasks'
        },
        {
          name: 'Waiting for admin',
          url: '/orders/waiting-for-admin',
          icon: 'fa fa-pause'
        },
        {
          name: 'Change delivery',
          url: '/orders/change-delivery',
          icon: 'fa fa-truck'
        },
        {
          name: 'Rejected by pharmacy',
          url: '/orders/rejected-by-pharmacy',
          icon: 'fa fa-exclamation-triangle'
        },
        {
          name: 'Payment failed',
          url: '/orders/payment-failed',
          icon: 'fa fa-times-circle',
          badge: {
            variant: 'success',
            text: 'NEW'
          }
        },
        {
          name: 'Additional payments',
          url: '/orders/additional-payments',
          icon: 'fa fa-credit-card',
          badge: {
            variant: 'success',
            text: 'NEW'
          }
        },
      ]
    },
    {
      name: 'Coupons',
      icon: 'fa fa-percent',
      url: '/coupons'
    },
    {
      name: 'Enterprises',
      icon: 'fa fa-percent',
      url: '/enterprises'
    },
    {
      name: 'Platforms',
      icon: 'fa fa-percent',
      url: '/platforms'
    },
    {
      name: 'Pricing',
      icon: 'fa fa-gbp',
      url: '/pricing'
    },
    {
      name: 'Subscriptions',
      icon: 'fa fa-credit-card',
      url: '/subscriptions'
    },
    {
      name: 'Packages',
      icon: 'fa fa-archive',
      url: '/packages'
    },
    {
      name: 'GP Notes',
      icon: 'fa fa-address-card',
      url: '/gp-notes'
    },
    {
      name: 'Pharmacies',
      url: '/pharmacies',
      icon: 'fa fa-ambulance'
    },
    {
      name: 'Prescribers',
      icon: 'fa fa-medkit',
      url: '/prescribers'
    },
    {
      name: 'Clinicians',
      url: '/doctors',
      icon: 'fa fa-heartbeat',
    },
    {
      name: "GPs",
      url: "/gps",
      icon: "fa fa-heartbeat",
    },
    {
      name: 'Formulary',
      icon: 'fa fa-medkit',
      url: '/formulary'
    },
    {
      name: 'Form Formulary',
      icon: 'fa fa-medkit',
      url: '/form-formulary'
    },
  ]
}
